import { render, staticRenderFns } from "./table313.vue?vue&type=template&id=4e20c996&scoped=true"
import script from "./table313.vue?vue&type=script&lang=js"
export * from "./table313.vue?vue&type=script&lang=js"
import style0 from "./table313.vue?vue&type=style&index=0&id=4e20c996&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20c996",
  null
  
)

export default component.exports